/* eslint-disable */
/* eslint-disable import/prefer-default-export */
// This rule should only be disabled whilst there is only one `export` in this file

export const I18N_CHANGE_LOCALE = `[I18N] CHANGE LOCALE`;
